import React from 'react';
import { useTranslation } from 'react-i18next';
import './AnnouncementBar.scss';

const AnnouncementBar = () => {
  const { t } = useTranslation();
  return (
    <div className="announcement-bar">
      <a href="/events" className="announcement-bar__link">
        {t('announcementBar.viewEvents')}
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
          <line x1="5" y1="12" x2="19" y2="12" />
          <polyline points="12 5 19 12 12 19" />
        </svg>
      </a>
    </div>
  );
};

export default AnnouncementBar;
